import { useEffect } from "react";
import { useSearchParams } from "react-router-dom"; // To get query parameters
import { db, storage } from "../components/firebase.js";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import HeroPages from "../components/HeroPages";
import Footer from "../components/Footer";


function BookingSuccess() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    console.log(sessionId)

    if (sessionId) {
      // Update the payment status in Firestore
      const updatePaymentStatus = async () => {
        try {
          const bookingsRef = collection(db, "BullesEyebookingsdata");
          const q = query(bookingsRef, where("sessionId", "==", sessionId));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const docId = querySnapshot.docs[0].id;
            const docRef = querySnapshot.docs[0].ref;

            // Update payment status to "Complete"
            await updateDoc(docRef, {
              paymentStatus: "Complete",
             // paymentConfirmedAt: new Date(),
            });

            window.alert("Payment confirmed! Your Booking is saved and confirmed. Please exit this page.");
          } else {
            window.alert("Payment uncofirmed! No booking saved.");
          }
        } catch (error) {
          console.error("Error updating payment status:", error);
          alert("An error occurred while confirming your payment. Please contact support.");
        }
      };

      updatePaymentStatus();
    }
  }, [searchParams]);


  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center', 
    height: '15vh', // Full viewport height
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif', 
  };

  const headingStyle = {
    fontWeight: 'bold', // Makes the text bolder
    fontSize: '3rem', marginTop:'40px' // Optional: adjust size as needed
  };

  const paragraphStyle = {
    fontWeight: 'bold', // Makes the text bolder
    fontSize: '1.8rem', // Optional: adjust size as needed
  };


  return (
    <>
    <section className="contact-page" >
    <HeroPages name="successful-payment" />
    <div className="container" style={containerStyle}>
      <h1 style={headingStyle}>Booking Confirmed!</h1>
      <p style={paragraphStyle}>Your booking has been confirmed. Please Exit This Page.</p>
    </div>
    <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Your Trusted Car Rental Partner</h2>
              
            </div>
          </div>
        </div>
        <Footer />
    </section>
     </>
  );
}

export default BookingSuccess;
